import { render } from "./DocumentsHistory.vue?vue&type=template&id=3b78ad58&scoped=true&ts=true"
import script from "./DocumentsHistory.vue?vue&type=script&lang=ts"
export * from "./DocumentsHistory.vue?vue&type=script&lang=ts"

import "./DocumentsHistory.vue?vue&type=style&index=0&id=3b78ad58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b78ad58"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip});
